<template>
  <div class="hay-loading-mask">
    <div class="hay-loading-spinner">
      <i class="hay-icon-loading"></i>
      <p class="hay-loading-text">{{ title }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'HayLoading',
  setup() {
    const title = ref('')
    const setTitle = (newTitle: string) => {
      title.value = newTitle
    }

    return { title, setTitle }
  }
})
</script>

<style lang="less" scoped>
.hay-loading-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  z-index: 9999;
  transition: opacity 0.3s;
  width: 100%;
  height: 100vh;
  .hay-loading-spinner {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    background: rgba(76, 76, 76, .7);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    i {
      display: block;
      width: 30px;
      height: 30px;
      border: 2px solid #fff;
      border-top-color: transparent;
      border-radius: 100%;

      animation: circle infinite 0.75s linear;
    }
    .hay-loading-text {
      color: #fff;
      margin: 3px 0;
      font-size: 14px;
    }
  }
}

.el-icon-loading {
  animation: circle infinite 0.75s linear;
}

// 转转转动画
@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
